module.exports = __webpack_public_path__ + "static/media/baja-y-desguace-de-vehiculos.12d4015c.png";